export default __webpack_public_path__ + "static/media/facebook.a58e0275.svg";